import { xorCrypt } from './crypto.util'

export function encodePinCode(pinCode: string) {
  return btoa(xorCrypt(pinCode))
}

export function decodePinCode(encodedPinCode: string) {
  return xorCrypt(atob(encodedPinCode))
}
